import React, { createContext, useContext, useState, useEffect, useRef } from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState([]);
  const [businessId, setBusinessId] = useState(null);
  const [businessName, setBusinessName] = useState("");
  const hydrated = useRef(false);

  useEffect(() => {
    const saved = localStorage.getItem("fuma_cart");
    if (saved) {
      const p = JSON.parse(saved);
      setItems(p.items || []); setBusinessId(p.businessId || null); setBusinessName(p.businessName || "");
    }
    hydrated.current = true;
  }, []);

  useEffect(() => {
    if (!hydrated.current) return;
    localStorage.setItem("fuma_cart", JSON.stringify({ items, businessId, businessName }));
  }, [items, businessId, businessName]);

  const addItem = (product, biz) => {
    if (businessId && businessId !== biz.id) {
      if (!window.confirm("Il carrello contiene prodotti di un'altra attività. Svuotare?")) return;
      setItems([]);
    }
    setBusinessId(biz.id); setBusinessName(biz.name);
    setItems((prev) => {
      const ex = prev.find((i) => i.product_id === product.id);
      if (ex) return prev.map((i) => i.product_id === product.id ? { ...i, qty: i.qty + 1 } : i);
      return [...prev, { product_id: product.id, name: product.name, price: product.price, qty: 1,
        kind: product.kind, slot: product.slot, duration_min: product.duration_min, service_id: product.service_id }];
    });
  };

  const updateQty = (pid, delta) => {
    setItems((prev) => prev.map((i) => i.product_id === pid ? { ...i, qty: Math.max(0, i.qty + delta) } : i).filter((i) => i.qty > 0));
  };

  const clear = () => { setItems([]); setBusinessId(null); setBusinessName(""); };
  const subtotal = items.reduce((s, i) => s + i.price * i.qty, 0);
  const count = items.reduce((s, i) => s + i.qty, 0);

  return (
    <CartContext.Provider value={{ items, businessId, businessName, addItem, updateQty, clear, subtotal, count }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
